import React, { useState } from 'react';
import { CloseButton, Button, Form } from 'react-bootstrap';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postDataBodyQuery } from 'api/getDataBodyQuery';

const UserCreatePopup = ({ setVisiblePopup }) => {
  const queryClient = useQueryClient();
  const [formData, setFormData] = useState({
    name: '',
    loginId: '',
    password: '',
    role: 'STUDENT',
    email: '',
    birth: '',
    mobile: '',
    divisionName: '',
    subDivisionName: '',
  });

  const closePopup = () => {
    setVisiblePopup(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const createUserMutation = useMutation({
    mutationFn: (body) => postDataBodyQuery('/signup?account_id=1', body),
    onSuccess: () => {
      alert('계정이 생성되었습니다.');
      queryClient.invalidateQueries({ queryKey: ['adminUserAll'] });
      queryClient.invalidateQueries({ queryKey: ['adminUserProfile'] });
      closePopup();
    },
    onError: (error) => {
      const errorMessage = error?.response?.data?.message || '계정 생성에 실패했습니다.';
      alert(errorMessage);
      console.error(error);
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.name || !formData.loginId || !formData.password || !formData.email || !formData.birth || !formData.mobile) {
      alert('필수 항목을 모두 입력해주세요.');
      return;
    }

    if (formData.role === 'STUDENT' && (!formData.divisionName || !formData.subDivisionName)) {
      alert('학생의 경우 학과와 세부학과를 입력해주세요.');
      return;
    }

    if (formData.password.length < 8) {
      alert('비밀번호는 8자 이상이어야 합니다.');
      return;
    }

    const body = {
      ...formData,
      agreementFlag: 'Y',
      state: 'ACTIVE',
    };

    // 학생이 아닌 경우 학과 정보 제거
    if (formData.role !== 'STUDENT') {
      delete body.divisionName;
      delete body.subDivisionName;
    }

    createUserMutation.mutate(body);
  };

  return (
    <>
      <div onClick={closePopup} className='backdrop w-100 h-100 position-fixed top-0 start-0' style={{ zIndex: '550' }}></div>
      <div
        className='bg-white position-fixed position-center p-4 rounded-2 popupContainer'
        style={{
          width: '90vw',
          maxWidth: '600px',
          maxHeight: '85vh',
          marginTop: '35px',
          overflowY: 'auto',
          zIndex: '600',
        }}
      >
        <div className='d-flex align-items-center justify-content-between'>
          <h3 className='h2 text-gray1 fw-bold py-2 mb-3'>계정 추가</h3>
          <CloseButton onClick={closePopup} style={{ fontSize: '24px' }} />
        </div>

        <Form onSubmit={handleSubmit}>
          <div className='row mb-3'>
            <label className='fw-bold col-3 d-flex align-items-center'>권한 <span className='text-danger ms-1'>*</span></label>
            <div className='col'>
              <Form.Select name='role' value={formData.role} onChange={handleChange}>
                <option value='STUDENT'>학생</option>
                <option value='TEACHER'>교수</option>
                <option value='ADMIN'>관리자</option>
              </Form.Select>
            </div>
          </div>

          <div className='row mb-3'>
            <label className='fw-bold col-3 d-flex align-items-center'>이름 <span className='text-danger ms-1'>*</span></label>
            <div className='col'>
              <Form.Control type='text' name='name' value={formData.name} onChange={handleChange} placeholder='이름 입력' />
            </div>
          </div>

          <div className='row mb-3'>
            <label className='fw-bold col-3 d-flex align-items-center'>학번/사번 <span className='text-danger ms-1'>*</span></label>
            <div className='col'>
              <Form.Control type='text' name='loginId' value={formData.loginId} onChange={handleChange} placeholder='학번 또는 사번 입력' />
            </div>
          </div>

          <div className='row mb-3'>
            <label className='fw-bold col-3 d-flex align-items-center'>비밀번호 <span className='text-danger ms-1'>*</span></label>
            <div className='col'>
              <Form.Control type='password' name='password' value={formData.password} onChange={handleChange} placeholder='8자 이상' />
            </div>
          </div>

          <div className='row mb-3'>
            <label className='fw-bold col-3 d-flex align-items-center'>이메일 <span className='text-danger ms-1'>*</span></label>
            <div className='col'>
              <Form.Control type='email' name='email' value={formData.email} onChange={handleChange} placeholder='이메일 입력' />
            </div>
          </div>

          <div className='row mb-3'>
            <label className='fw-bold col-3 d-flex align-items-center'>생년월일 <span className='text-danger ms-1'>*</span></label>
            <div className='col'>
              <Form.Control type='date' name='birth' value={formData.birth} onChange={handleChange} />
            </div>
          </div>

          <div className='row mb-3'>
            <label className='fw-bold col-3 d-flex align-items-center'>휴대폰 <span className='text-danger ms-1'>*</span></label>
            <div className='col'>
              <Form.Control type='text' name='mobile' value={formData.mobile} onChange={handleChange} placeholder='010-0000-0000' />
            </div>
          </div>

          {formData.role === 'STUDENT' && (
            <>
              <div className='row mb-3'>
                <label className='fw-bold col-3 d-flex align-items-center'>학과 <span className='text-danger ms-1'>*</span></label>
                <div className='col'>
                  <Form.Control type='text' name='divisionName' value={formData.divisionName} onChange={handleChange} placeholder='학과 입력' />
                </div>
              </div>

              <div className='row mb-3'>
                <label className='fw-bold col-3 d-flex align-items-center'>세부학과 <span className='text-danger ms-1'>*</span></label>
                <div className='col'>
                  <Form.Control type='text' name='subDivisionName' value={formData.subDivisionName} onChange={handleChange} placeholder='세부학과 입력' />
                </div>
              </div>
            </>
          )}

          <div className='d-flex justify-content-center gap-2 mt-4 pt-3 border-top'>
            <Button type='submit' variant='primary' disabled={createUserMutation.isPending}>
              {createUserMutation.isPending ? '생성 중...' : '생성'}
            </Button>
            <Button type='button' variant='secondary' onClick={closePopup}>
              취소
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
};

export default UserCreatePopup;
